export const normalizarTelefone = (bruto) => {
  let n = String(bruto || "")
    .replace(/@c\.us/g, "")
    .replace(/@g\.us/g, "")
    .replace(/\D/g, "");
  if (!n) return "";

  
  if (n.startsWith("55") && (n.length === 13 || n.length === 12)) {
    n = n.slice(2);
  }

  if (n.length === 10 && /^[6-9]/.test(n.slice(2))) {
    n = `${n.slice(0, 2)}9${n.slice(2)}`;
  }

  return n;
};

export const formatarTelefone = (bruto) => {
  if (!bruto) return "";
  const clean = String(bruto).replace(/@c\.us/g, "").replace(/@g\.us/g, "").trim();
  const n = normalizarTelefone(clean);

  if (n.length === 11) {
    return `+55 (${n.slice(0, 2)}) ${n.slice(2, 7)}-${n.slice(7)}`;
  }
  if (n.length === 10) {
    return `+55 (${n.slice(0, 2)}) ${n.slice(2, 6)}-${n.slice(6)}`;
  }

  return clean;
};

export const formatarNomeOuTelefone = (nome, numero) => {
  const cleanNome = String(nome || "").replace(/@c\.us/g, "").replace(/@g\.us/g, "").trim();
  const cleanNumero = String(numero || "").replace(/@c\.us/g, "").replace(/@g\.us/g, "").trim();

  if (!cleanNome) {
    return formatarTelefone(cleanNumero);
  }

  const digitsOnly = cleanNome.replace(/\D/g, "");
  const nonDigits = cleanNome.replace(/[\d\s+\-()]/g, "");

  if (nonDigits.length === 0 && digitsOnly.length >= 8) {
    return formatarTelefone(digitsOnly);
  }

  return cleanNome;
};

export default formatarTelefone;
